import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const MileageIcon = ({
  width = '51',
  height = '51'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2407_43733)">
        <mask
          id="mask0_2407_43733"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="51"
          height="51"
        >
          <path d="M50.4917 0H0V50.4917H50.4917V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2407_43733)">
          <path
            d="M25.2459 50.4917C39.1888 50.4917 50.4917 39.1888 50.4917 25.2459C50.4917 11.303 39.1888 0 25.2459 0C11.303 0 0 11.303 0 25.2459C0 39.1888 11.303 50.4917 25.2459 50.4917Z"
            fill="#F2FFFD"
          />
          <mask
            id="mask1_2407_43733"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="31"
            height="31"
          >
            <path
              d="M40.3933 10.0981H10.0984V40.3931H40.3933V10.0981Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_2407_43733)">
            <path
              d="M21.0742 33.5682C19.9997 35.1832 18.8775 36.3693 18.3987 36.8475C18.2652 36.9809 18.0541 36.9804 17.9211 36.8464C16.879 35.797 12.7744 31.3563 12.7744 26.517C12.7744 25.0338 13.3417 23.6114 14.3516 22.5627C15.3615 21.514 16.7312 20.9248 18.1594 20.9248C19.5876 20.9248 20.9573 21.514 21.9672 22.5627C22.9771 23.6114 23.5444 25.0338 23.5444 26.517C23.5444 28.2219 23.0439 29.8691 22.348 31.3354"
              stroke="#99999A"
              strokeWidth="1.08495"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M36.4883 20.6806C35.667 21.9151 34.8091 22.8219 34.4432 23.1874C34.3409 23.2894 34.1796 23.289 34.0781 23.1866C33.2812 22.3844 30.1436 18.9896 30.1436 15.2901C30.1436 14.1563 30.5773 13.069 31.3492 12.2672C32.1211 11.4656 33.1684 11.0151 34.2601 11.0151C35.3518 11.0151 36.3991 11.4656 37.171 12.2672C37.9432 13.069 38.3769 14.1563 38.3769 15.2901C38.3769 16.5935 37.9942 17.8527 37.4621 18.9736"
              stroke="#99999A"
              strokeWidth="1.08495"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.1597 29.6502C20.0188 29.6502 21.5258 28.1432 21.5258 26.2841C21.5258 24.425 20.0188 22.918 18.1597 22.918C16.3006 22.918 14.7936 24.425 14.7936 26.2841C14.7936 28.1432 16.3006 29.6502 18.1597 29.6502Z"
              fill="#73767D"
            />
            <path
              d="M18.1597 29.6502C20.0188 29.6502 21.5258 28.1432 21.5258 26.2841C21.5258 24.425 20.0188 22.918 18.1597 22.918C16.3006 22.918 14.7936 24.425 14.7936 26.2841C14.7936 28.1432 16.3006 29.6502 18.1597 29.6502Z"
              fill="#96A2C2"
            />
            <path
              d="M18.1597 29.6502C20.0188 29.6502 21.5258 28.1432 21.5258 26.2841C21.5258 24.425 20.0188 22.918 18.1597 22.918C16.3006 22.918 14.7936 24.425 14.7936 26.2841C14.7936 28.1432 16.3006 29.6502 18.1597 29.6502Z"
              fill="#31B59F"
            />
            <path
              d="M18.1597 29.6502C20.0188 29.6502 21.5258 28.1432 21.5258 26.2841C21.5258 24.425 20.0188 22.918 18.1597 22.918C16.3006 22.918 14.7936 24.425 14.7936 26.2841C14.7936 28.1432 16.3006 29.6502 18.1597 29.6502Z"
              stroke="#99999A"
              strokeWidth="1.08495"
            />
            <path
              d="M34.2604 17.4873C35.57 17.4873 36.6317 16.4256 36.6317 15.1159C36.6317 13.8063 35.57 12.7446 34.2604 12.7446C32.9507 12.7446 31.889 13.8063 31.889 15.1159C31.889 16.4256 32.9507 17.4873 34.2604 17.4873Z"
              fill="#73767D"
            />
            <path
              d="M34.2604 17.4873C35.57 17.4873 36.6317 16.4256 36.6317 15.1159C36.6317 13.8063 35.57 12.7446 34.2604 12.7446C32.9507 12.7446 31.889 13.8063 31.889 15.1159C31.889 16.4256 32.9507 17.4873 34.2604 17.4873Z"
              fill="#96A2C2"
            />
            <path
              d="M34.2604 17.4873C35.57 17.4873 36.6317 16.4256 36.6317 15.1159C36.6317 13.8063 35.57 12.7446 34.2604 12.7446C32.9507 12.7446 31.889 13.8063 31.889 15.1159C31.889 16.4256 32.9507 17.4873 34.2604 17.4873Z"
              fill="#31B59F"
            />
            <path
              d="M34.2604 17.4873C35.57 17.4873 36.6317 16.4256 36.6317 15.1159C36.6317 13.8063 35.57 12.7446 34.2604 12.7446C32.9507 12.7446 31.889 13.8063 31.889 15.1159C31.889 16.4256 32.9507 17.4873 34.2604 17.4873Z"
              stroke="#99999A"
              strokeWidth="1.08495"
            />
            <path
              d="M21.3136 35.9336C23.6445 36.2387 25.2459 36.8715 25.2459 37.6025C25.2459 38.6316 22.0733 39.4656 18.1597 39.4656C14.2461 39.4656 11.0735 38.6316 11.0735 37.6025C11.0735 36.8715 12.6749 36.2387 15.0058 35.9336"
              stroke="#99999A"
              strokeWidth="1.08495"
              strokeLinecap="round"
            />
            <path
              d="M36.6714 22.4888C38.4532 22.722 39.6775 23.2057 39.6775 23.7645C39.6775 24.5511 37.2521 25.1888 34.2604 25.1888C31.2687 25.1888 28.8433 24.5511 28.8433 23.7645C28.8433 23.2057 30.0676 22.722 31.8494 22.4888"
              stroke="#99999A"
              strokeWidth="1.08495"
              strokeLinecap="round"
            />
            <path
              d="M25.9263 35.9343C33.3488 35.1529 35.009 33.8281 35.009 32.9068C35.009 31.4383 29.0749 30.5627 29.0749 28.9877C29.0749 28.3166 31.2 27.2423 33.9346 26.8516"
              stroke="#99999A"
              strokeWidth="1.08495"
              stroke-miterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.6096 20.6289L12.648 19.5386"
              stroke="#31B59F"
              strokeWidth="0.813709"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.1848 22.8618L10.7358 22.7144"
              stroke="#31B59F"
              strokeWidth="0.813709"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.0224 19.5597L16.0927 18.105"
              stroke="#31B59F"
              strokeWidth="0.813709"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2407_43733">
          <rect width="50.7212" height="50.7212" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MileageIcon
